import { useEffect, useState, type ReactNode } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import { LoadingButton } from './LoadingButton';

export interface ConfirmProps {
  open: boolean;
  title: string;
  text?: ReactNode;
  confirmLabel?: string;
  danger?: boolean;
  /** When set, the user must type this exact text to enable the button. */
  typed?: string;
  busy?: boolean;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: ReactNode;
}

export function ConfirmDialog({ open, title, text, confirmLabel = 'Confirm', danger, typed, busy, confirmDisabled, onConfirm, onClose, children }: ConfirmProps) {
  const [value, setValue] = useState('');
  useEffect(() => {
    if (open) setValue('');
  }, [open]);
  const ok = (!typed || value === typed) && !confirmDisabled;
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {text && <DialogContentText component="div">{text}</DialogContentText>}
        {children}
        {typed && (
          <TextField
            sx={{ mt: 2 }}
            fullWidth
            autoFocus
            label={`Type "${typed}" to confirm`}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <LoadingButton variant="contained" color={danger ? 'error' : 'primary'} disabled={!ok} loading={busy} onClick={onConfirm}>
          {confirmLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
